import { useEffect, useState } from 'react'
import clsx from 'clsx'
import { retouchWPText } from '../../../lib/txtUtil'
import { imgSrc, linkMaker, onLoad } from '../../../lib/listUtil'
import NewsCell from '../cell/NewsCell'
import PostsCell from '../cell/PostsCell'
import BlogCell from '../cell/BlogCell'
import CommonCell from '../cell/CommonCell'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'

const ListItemInner=({type, extraClass, params, children})=> {
  return (
    params ? (
      <Link to={params.link}><div className={clsx("list_item_inner", type, extraClass)}>
        <div className="event-image-wrapper">
          {
            params.thumb && <img width={280} height={80} alt="thumb" src={params.thumb} className='event-image image' onLoad={onLoad} />
          }
        </div>
        {children}
      </div>
      </Link>
    ) : <div/>
  )
}

//type: (news, posts, blog, tv)
const ListItem =({item, type, extraClass})=> {
  const [params, setParams] = useState(null);

  useEffect(()=> {
    if(!item) return;
    const dev = item.node ? item.node : item;
    const {databaseId, excerpt, featuredImage, thumb, date,  ...rest} = dev;
    let txt;
    if(excerpt) txt = retouchWPText(excerpt);
    let p = {
      ...rest,
      subtitle: dayjs(date).format('YYYY-MM-DD'),
      link: linkMaker(type, date, databaseId),
      thumb: thumb || featuredImage,
      text: txt,
      type: dev.type && dev.type
    };
    p.thumb = imgSrc(p.thumb);

    switch(type){
      case 'blog':
        if(item.specials && item.specials.nodes && item.specials.nodes[0]) p.subtitle = item.specials.nodes[0].name;
        break;

      case 'tv':
        const {regularACF, content} = rest;
        p.text = content;
        if(regularACF && regularACF.regularIconimg) p.thumb = regularACF.regularIconimg.m;
        break;
      default:
        break;
    }

    setParams(p);
  }, [item, type]);

  return (
    <ListItemInner type={type} extraClass={extraClass} params={params}>
      {
        type === 'news' ? <NewsCell params={params} /> :
          type === 'posts' ? <PostsCell params={params} /> :
            type === 'blog' ? <BlogCell params={params} /> :
            <CommonCell type={type} params={params} />
      }
    </ListItemInner>
  )
}

export default ListItem
